import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';
import { MasterInstallationModel } from '@core/domain/model/master/master-installation.model';
import { StringIdName } from '@core/domain/model/master/string-id-name.model';

export const masterActions = createActionGroup({
  source: 'Master',
  events: {
    fetchSocieties: emptyProps(),
    setSocieties: props<{ data: MasterSocietyModel[] | null }>(),
    errorSocieties: props<{ error: string }>(),
    fetchInstallations: emptyProps(),
    setInstallations: props<{ data: MasterInstallationModel[] | null }>(),
    errorInstallations: props<{ error: string }>(),
    fetchRoadTypes: emptyProps(),
    setRoadTypes: props<{ data: StringIdName[] | null }>(),
    errorRoadTypes: props<{ error: string }>(),
    fetchSelfConsumptions: emptyProps(),
    setSelfConsumptions: props<{ data: StringIdName[] | null }>(),
    errorSelfConsumptions: props<{ error: string }>(),
    fetchCups: emptyProps(),
    setCups: props<{ data: StringIdName[] | null }>(),
    errorCups: props<{ error: string }>(),
    fetchSubsectionType: emptyProps(),
    setSubsectionType: props<{ data: StringIdName[] | null }>(),
    errorSubsectionType: props<{ error: string }>(),
    fetchInstallationType: emptyProps(),
    setInstallationType: props<{ data: StringIdName[] | null }>(),
    errorInstallationType: props<{ error: string }>(),
  },
});
